package com.shadowings.gero.presentation.model

import com.shadowings.gero.domain.model.ThemeMode
import com.shadowings.gero.domain.model.UserData

data class AppUiState(
    val tutorialDone: Boolean? = null,
    val isDatabaseReady: Boolean = false,
    val language: String = "",
    val themeMode: ThemeMode = ThemeMode.System,
    val hapticEnabled: Boolean = true,
    val showChangelog: Boolean = false,
    val showDailyBonus: Boolean = false,
    val userData: UserData = UserData(),
)
